import { PAGE_REQUEST } from 'store/app/types';

import { types } from './actions';

const initialState = {
  isDeepCopyingQuoteItemInPlace: false,
  isOpen: false,
  quoteItemId: null,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case PAGE_REQUEST:
      return {
        ...initialState,
      };
    case types.DEEP_COPY_QUOTE_ITEM_IN_PLACE_REQUEST:
      return {
        ...state,
        isDeepCopyingQuoteItemInPlace: true,
      };
    case types.DEEP_COPY_QUOTE_ITEM_IN_PLACE_ERROR:
    case types.DEEP_COPY_QUOTE_ITEM_IN_PLACE_SUCCESS:
      return {
        ...state,
        isDeepCopyingQuoteItemInPlace: false,
      };
    case types.MODAL_OPEN:
      return {
        ...state,
        isOpen: true,
        quoteItemId: payload.quoteItemId,
      };
    case types.MODAL_CLOSE:
      return {
        ...state,
        isOpen: false,
        quoteItemId: null,
      };
    default:
      return state;
  }
};

const getScope = (state) =>
  state.modules.quotes.quoteItemNav.deepCopyInPlaceModal;

export const getIsDeepCopyingQuoteItemInPlace = (state) =>
  getScope(state).isDeepCopyingQuoteItemInPlace;

export const getIsOpen = (state) => getScope(state).isOpen;

export const getQuoteItemId = (state) => getScope(state).quoteItemId;

export default reducer;
